import { render, staticRenderFns } from "./SignRecordTable.vue?vue&type=template&id=061e3d5a&scoped=true"
import script from "./SignRecordTable.vue?vue&type=script&lang=js"
export * from "./SignRecordTable.vue?vue&type=script&lang=js"
import style0 from "./SignRecordTable.vue?vue&type=style&index=0&id=061e3d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061e3d5a",
  null
  
)

export default component.exports